export default __webpack_public_path__ + "static/media/E02.d79312c8.mp3";